import { ViewportSize } from './../../../shared/state/ui/ui.store';
import { ToastService } from './../../../shared/services/toast/toast.service';
import { transformModel, uuidv4 } from './../../../shared/utils';
import { UiQuery } from './../../../shared/state/ui/ui.query';
import { SessionQuery } from './../../../core/state/session/session.query';
import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SbRoutingButton, SbPath } from '@models';
import { TranslateService } from '@ngx-translate/core';
import {
    SbDataService,
    SbEvent,
    SbEventBusService,
    SbEventTopic,
    SbStorageService
} from '../../services';
import {
    ColDef,
    ColumnApi,
    GridApi,
    GridOptions,
    RowNode,
    ValueSetterParams
} from 'ag-grid-community';
import 'ag-grid-enterprise';
import { get } from 'dot-prop';
import { evaluate } from 'mathjs';
import { Observable, Subscription } from 'rxjs';
import {
    SbAgTableContext,
    SbMenuItem
} from 'src/app/legacy/widgets/sb-ag-table/sb-ag-table-context';
import { SbHost } from '@models/sb-host-enum';
import { Sbmessage } from '@models/sb-messages';
import { SbSnackbarComponent } from '../../sb-snackbar/sb-snackbar.component';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import getNumericCellEditor from './cell-editor-functions';
import { FormattingFunctions } from './formatting-functions';
import { SbAgDetailsRenderer } from './sb-ag-details-renderer/sb-ag-details-renderer';
import { SbAgTableColDef } from './sb-ag-table-coldef';
import { SbAgTableButtonRenderer } from './sb-ag-table-button-renderer/sb-ag-table-button-renderer.component';

import { SbAgTableLinkRendererComponent } from './sb-ag-table-link-renderer/sb-ag-table-link-renderer.component';
import { SbConfirmDialogService } from '../../sb-confirm-dialog/sb-confirm-dialog.service';
import { FieldMapping } from '../../sb-form-configuration/sb-form-context';
import { LocalStorageService } from '../../../shared/services/local-storage.service';
import { AcctsQuery } from 'src/app/shared/state/accts/accts.query';
import { Instrument } from '../../../shared/state/instruments/instrument.model';
import { AmendService } from 'src/app/shared/services/amend.service';

@Component({
    selector: 'app-sb-ag-table',
    templateUrl: './sb-ag-table.component.html',
    styleUrls: ['./sb-ag-table.component.scss']
})
export class SbAgTableComponent extends BaseWidgetComponent implements OnInit, OnDestroy {
    @Input() context: SbAgTableContext;

    @ViewChild('agGrid', { static: true }) agGridDomElement: ElementRef;
    @ViewChild('agGridView', { static: true }) agGridDomElementView: ElementRef;
    tableIsAmendable = false;

    @HostBinding('class.d-none') get hasNoContent() {
        return (
            this.rowData.length === 0 &&
            !this.isLoading &&
            !this.isExcludedFromBeingHidden(this.context.widgetId)
        );
    }

    currentContext =
        this.activatedRoute.snapshot.url[this.activatedRoute.snapshot.url.length - 1]
            .path;

    public printLayout: boolean;
    private gridApi: GridApi;
    private gridColumnApi: ColumnApi;
    private viewGridApi: GridApi;
    private viewColumnApi: ColumnApi;

    msgs: Sbmessage[] = [];
    gridOptions: GridOptions;
    detailCellRenderer;
    frameworkComponents;
    detailRowAutoHeight: boolean = true;
    masterDetail: boolean = false;
    detailCellRendererParams;
    editType: String;
    columnDefs: SbAgTableColDef[];
    defaultColDef: any;
    sideBar;
    initialDataLoaded = false;
    saveEnabled = false;
    paginated: boolean;
    pageSize: number;
    buttons: SbRoutingButton[];
    rowData: any[];
    columnTypes: any;
    initialRowHeight = 32;
    rowHeight = 32;
    isCondensed = false;
    compactIcon = 'fa ui-icon-unfold-less';
    compactTooltip = 'Compact View';
    autoHeightIcon = 'fa ui-icon-import-export';
    autoHeightToolTip = 'Auto height';
    autoGroupColumnDef;
    domLayout: string;
    showAdvancedToolbar: boolean;
    displayDropdown = false;
    display = 'none';
    rightPanelView = '';
    displayTableViewPanel = false;
    selectedColumns: string[] = [];
    view: any;
    singleView: any;
    views: any = [];
    tabViews: any = [];
    view_name: string;
    viewId: number;
    viewColumnDefs: ColDef[];
    viewRowData: any[];
    viewGridOptions: GridOptions;
    originalColumnList = [];
    submitSubscription: Subscription;
    cancelSubscription: Subscription;
    viewPortSize$: Observable<ViewportSize>;
    /**
     * ColDef for details toggle - added to coldefs if we have "responsiveColumns". Hidden by default. Will be displayed if a details table should be displayed.
     */
    detailsToggleColDef: ColDef = {
        colId: 'detailstoggle',
        headerName: '',
        valueGetter: '""',
        cellRenderer: 'agGroupCellRenderer',
        hide: true,
        width: 20,
        resizable: false,
        suppressSizeToFit: true,
        sortable: false
    };
    /**
     * Function for custom aggregation values in group footers
     * Any column using custom aggregation must:
     *
     * 1. define an aggFunc in the colDef
     *  Can be a random string if the aggregationFunctionResult from the values
     *  in the column should not be used as part of the custom function.
     *  Ex. "aggFunc": "custom" if aggregated value of columns cell values should not be used.
     *  Ex. "aggFunc": "sum" if the sum of all this columns values should be used as part of
     *  the custom aggregation function (customAggFunc).
     *
     * 2. define a customAggFunc in the colDef (property not part of ag-grid ColDef api)
     *  Should be a math expression after replacing colId properties with results from aggregation functions.
     *  Ex. "customAggFunc": "colId.otherColumnIdOne * colId.otherColumnIdTwo"
     *  [NOTE] For this to work the other colDefs refered to must have colId properties set.
     *  If not they will be assigned "field" value as id, or in case of valueGetters they will get random integer values.
     *  (field value can be used but avoid it for clarity by setting colId explicitly)
     *
     * 3. Use the prefix colId. followed by the colId for the columns used in the aggregation expression.
     *  Ex. "customAggFunc": "colId.marketValue - colId.acquisitionValue"
     *  [NOTE] If one colId partially matches another it can cause issues with string replacements in this function.
     *  Ex. Avoid: "customAggFunc": "colId.change - colId.changeInMarketValue"
     */
    groupAddGroupNodesFunc: (nodes: RowNode[]) => any = function (nodes: RowNode[]) {
        if (this.gridColumnApi && nodes.length > 0) {
            const aggColumns = this.gridColumnApi.getValueColumns();
            // Store all cell value arrays in values object for each column based on colId
            const values = {};
            nodes.forEach((node) => {
                // const data = node.group ? node.aggData : node.data; Todo - why check if group here?
                aggColumns.forEach((col) => {
                    // Should only happen during first iteration
                    if (!values.hasOwnProperty(col.colId)) {
                        values[col.colId] = [];
                    }
                    values[col.colId].push(this.gridApi.getValue(col.colId, node));
                });
            });

            const aggFuncs = this.gridApi.aggFuncService.aggFuncsMap;
            const result = {};
            const customAggValues = [];
            const aggColIds = [];
            aggColumns.forEach((col) => {
                aggColIds.push(col.colId);
                if (aggFuncs.hasOwnProperty(col.colDef.aggFunc)) {
                    // Use standard ag-grid, or registered custom, aggFunc.
                    result[col.colId] = aggFuncs[col.colDef.aggFunc](values[col.colId]);
                }
                if (col.userProvidedColDef.customAggFunc) {
                    // Save column to do math calculation on other aggregation results.
                    // Has to be done after all others are done if using results from other aggregation functions.
                    customAggValues.push(col);
                }
            });

            customAggValues.forEach((col) => {
                const customFuncString: string = col.userProvidedColDef.customAggFunc;
                let customFuncResult: string = customFuncString;
                aggColIds.forEach((colId) => {
                    customFuncResult = customFuncResult.replace(
                        'colId.' + colId,
                        result[colId]
                    );
                });
                try {
                    const colRes = evaluate(customFuncResult);
                    // Todo: Use precision (math.format(colRes, {precision: n})) or rounding (math.round(colRes, n))
                    // checking type of number since math expressions can return NaN if dividing by zero.
                    result[col.colId] = colRes ? colRes : 0;
                } catch (error) {
                    console.error(
                        'Error in aggregation function: Could not evaluate: ' +
                            customFuncResult
                    );
                    result[col.colId] = 0;
                }
            });
            return result;
        }
        return {};
    }.bind(this);

    public get isHidden() {
        return !(
            this.rowData.length > 0 ||
            this.context.displayWhenNoData ||
            this.isLoading ||
            this.displayDropDownButton() ||
            this.buttons ||
            (this.context.widgetId !== 'list-limits' &&
                this.context.widgetId !== 'list-transactions')
        );
    }

    public get ownsHeaderText() {
        return this.context.hasOwnProperty('headerText') && this.context.headerText;
    }

    constructor(
        dateFormatter: DatePipe,
        numberFormatter: DecimalPipe,
        percentageFormatter: PercentPipe,
        dataService: SbDataService,
        protected router: Router,
        private http: HttpClient,
        eventBus: SbEventBusService,
        activatedRoute: ActivatedRoute,
        private storageService: SbStorageService,
        private renderer: Renderer2,
        public dialog: MatDialog,
        protected sessionQuery: SessionQuery,
        private snackBar: MatSnackBar,
        private translateService: TranslateService,
        private ui: UiQuery,
        public confirmDialogService: SbConfirmDialogService,
        private toastService: ToastService,
        localStorageService: LocalStorageService,
        private acctsQuery: AcctsQuery,
        private _amendService: AmendService
    ) {
        super(dataService, localStorageService, eventBus, activatedRoute, router);
        this.autoTriggerDataLoad = true;
        this.setAutoGroupColumnDef();
        this.responseHandler = this.setData;
        const formattingFunctions = new FormattingFunctions(
            dateFormatter,
            numberFormatter,
            percentageFormatter,
            translateService
        );
        this.columnTypes = formattingFunctions.columnTypes;
        this.rowHeight = this.initialRowHeight;
        this.detailCellRenderer = 'myDetailCellRenderer';
        this.detailCellRendererParams = { refreshStrategy: '' };
        this.frameworkComponents = {
            myDetailCellRenderer: SbAgDetailsRenderer,
            sbAgTableButtonCellRenderer: SbAgTableButtonRenderer,
            sbAgTableLinkRendererComponent: SbAgTableLinkRendererComponent
        };
    }

    getRowNodeId(data) {
        if (this.context.idKey) {
            return '' + data[this.context.idKey];
        } else if (data.hasOwnProperty('id')) {
            return data.id;
        } else {
            return uuidv4();
        }
    }

    toggleDropdown() {
        this.displayDropdown = !this.displayDropdown;

        if (this.displayDropdown) {
            this.display = 'block';
        } else {
            this.display = 'none';
        }
    }

    ngOnInit() {
        // enable transactions table to have amendable rows
        this.tableIsAmendable = this.context.widgetId === 'list-transactions';
        this.rowData = [];
        this.gridOptions = Object.assign(
            {},
            this.context.gridOptions ? this.context.gridOptions : {},
            {
                context: {
                    componentParent: this
                },
                popupParent: document.querySelector('body'),
                detailRowAutoHeight: true,
                getContextMenuItems: (params) => {
                    this.getContextMenuItems(params);
                },
                getRowNodeId: (data) => {
                    return this.getRowNodeId(data);
                },
                getRowHeight: (params) => {
                    const isDetailRow = params.node.detail;
                    /**
                     * If all groups are expanded by default the grid calls getRowHeight before the onGridReady even for the details row (meaning gridColumnApi will be undefined).
                     * Hence if using details, explicitly set groupDefaultExpanded to the number of groups you want expanded.
                     */
                    if (isDetailRow && this.gridColumnApi) {
                        // Since we are explicitly using "getRowHeight" we can't rely on "detailsPanelAutoHeight" --> Set row height for details panel based on number of "hidden" values
                        const displayedColIds = this.gridColumnApi
                            .getAllDisplayedColumns()
                            .map((c) => c.getColId());
                        const numberOfHiddenCols = this.context.responsiveColumns.filter(
                            (c) => displayedColIds.indexOf(c.colId) < 0
                        ).length;
                        // Width of each is 33% - hence increase height after each triple. I.e. one row height for 1-3, two row heights for 4-6 and so on.
                        return (Math.floor((numberOfHiddenCols - 1) / 3) + 1) * 80;
                    } else {
                        return this.rowHeight;
                    }
                },
                components: {
                    numericCellEditor: getNumericCellEditor()
                },
                floatingFiltersHeight: 30
            }
        );
        super.ngOnInit();

        this.isSynchronizationOn = this.context.widgetId === 'top-holdings-widget';

        this.editType = this.context.editType;
        this.sideBar = 'columns';
        this.saveEnabled = this.context.saveStateEnabled;
        // Clone since we're adding/removing items from the columnDefs
        this.columnDefs = structuredClone(this.context.columnConfig);
        // Add context menu items as button columns.
        this.context.contextMenuItems
            ?.filter((mi) => this.sessionQuery.hasScopeAccess(mi.accessRight))
            .forEach((menuItem) => this.columnDefs.push(this.getButtonColDef(menuItem)));

        if (this.context.addCompanyOverviewLink) {
            this.columnDefs.push(this.getLinkButtonColDef());
        }
        this.columnDefs = this.columnDefs.map((column) => {
            const updatedColumn = { ...column };

            if (updatedColumn.field === 'instrument.instrumentData.type') {
                updatedColumn.valueGetter = (params) => {
                    if (params.data && params.data.instrument) {
                        if (
                            params.data.instrument.instrumentData &&
                            params.data.instrument.instrumentData.privateAssetType
                        ) {
                            return 'PRIVATE_ASSET';
                        }
                        return params.data.instrument.instrumentData.type;
                    }
                    return null;
                };
            }
            // if textfilter then hidding filter icon in floating-filter
            if (updatedColumn.filter === 'agTextColumnFilter') {
                updatedColumn.floatingFilterComponentParams = {
                    suppressFilterButton: true
                };
            }

            // if column is for instrumentName and widget is portfolio-summary-* ...
            if (
                updatedColumn.field === 'instrumentName' &&
                (this.context.widgetId.indexOf('portfolio-summary-') > -1 ||
                    this.context.widgetId === 'positions-table-private-assets' ||
                    this.context.widgetId === 'positions-table-private-equity')
            ) {
                // ...replace content with link to the instrument
                updatedColumn.cellRenderer = (params) => {
                    const rowData = params.data;
                    const instrument: Instrument = rowData?.instrument;
                    switch (instrument?.type) {
                        case 'PRIVATE_ASSET':
                            return `<a class="ag-table-link" href="/private-assets/overview/${instrument.instrumentData.privateAssetType}(modal:action/asset/view/${instrument.instrumentId})">${params.value}</a>`;
                        case 'COMMERCIAL_REAL_ESTATE':
                            return `<a class="ag-table-link" href="/commercial-real-estate(modal:action/commercial-real-estate/view/${instrument.instrumentId})">${params.value}</a>`;
                        case 'PE_SHAREHOLDER_CONTRIBUTION':
                        case 'PE_OPTION':
                        case 'PE_CONVERTIBLE':
                        case 'PE_OTHER_SHARE':
                        case 'PE_PREF_SHARE':
                        case 'PRIVATE_EQUITY':
                            return `<a class="ag-table-link" href="/private-equity/${instrument.underlyingInstrumentId}">${params.value}</a>`;
                        case 'EQUITY':
                            return `<a class="ag-table-link" href="/equities/${instrument.instrumentId}">${params.value}</a>`;
                        case 'FUND':
                            return `<a class="ag-table-link" href="/mutual-funds/${instrument.instrumentId}">${params.value}</a>`;
                        case 'ETF':
                            return `<a class="ag-table-link" href="/exchange-traded-funds/${instrument.instrumentId}">${params.value}</a>`;
                        case 'CERT':
                            return `<a class="ag-table-link" href="/cert/${instrument.instrumentId}">${params.value}</a>`;
                        case 'PRIVATE_FUND':
                            return `<a class="ag-table-link" href="/private-equity-fund/overview/${instrument.instrumentId}">${params.value}</a>`;
                        case 'BOND':
                            return `<a class="ag-table-link" href="/fixed-income/${instrument.instrumentId}">${params.value}</a>`;
                        default:
                            return params.value;
                    }
                };
            }

            return updatedColumn;
        });
        this.defaultColDef = this.context.defaultColumnConfig;
        this.sideBar = this.context.sideBar || false;
        this.paginated = this.context.paginated || false;
        this.pageSize =
            this.context.paginated && this.context.pageSize
                ? this.context.pageSize
                : undefined;
        this.buttons = this.context.buttons || [];
        this.domLayout = this.context.gridOptions
            ? this.context.gridOptions.domLayout
            : undefined;
        this.showAdvancedToolbar = this.context.showAdvancedToolbar;
        if (this.context?.responsiveColumns) {
            // Add toggle column first.
            this.masterDetail = true;
            this.columnDefs.unshift(this.detailsToggleColDef);
        }

        // Loading of initial cell editor values
        this.columnDefs.forEach((cd) => {
            cd.icons = {
                filter:
                    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-filter" width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">\n' +
                    '   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>\n' +
                    '   <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"></path>\n' +
                    '</svg>'
            };
            cd.valueSetter = this.onCellEditingChanged.bind(this);
            if (cd.editable) {
                cd.suppressKeyboardEvent = this.onKeyDown.bind(this);
            } else {
                cd.editable = this.editable.bind(this);
            }

            cd.cellStyle = this.cellStyle.bind(this);

            if (cd.cellEditorParams && cd.cellEditorParams.path) {
                const url = this.dataService.getResourceUrl(cd.cellEditorParams.path);
                this.dataService.getData(url).subscribe(
                    (response) => {
                        cd.cellEditorParams.values = response;
                    },
                    () => {
                        console.error(
                            'Failed to load initial cell data values' + cd.field
                        );
                    }
                );
            }
        });
        this.registerEventListeners();
    }

    getButtonColDef(menuItem: SbMenuItem): SbAgTableColDef {
        return {
            ...{
                field: '',
                cellRenderer: 'sbAgTableButtonCellRenderer',
                cellRendererParams: {
                    menuItem: menuItem
                }
            },
            ...(menuItem.colDef ? menuItem.colDef : {})
        };
    }

    getLinkButtonColDef(): SbAgTableColDef {
        return {
            field: '',
            cellRenderer: 'sbAgTableLinkRendererComponent',
            cellRendererParams: {},
            suppressMovable: true,
            width: 32,
            minWidth: 32,
            maxWidth: 40
        };
    }

    private toggleResponsiveColumns(breakpoint: string) {
        const viewportSizes: string[] = ['xs', 'sm', 'md', 'lg', 'xl'];
        let displayToggleColumn = false;
        this.context.responsiveColumns.forEach((c) => {
            const shouldBeVisible =
                viewportSizes.indexOf(c.hideBelowBreakpoint) <
                viewportSizes.indexOf(breakpoint);
            this.gridColumnApi?.setColumnVisible(c.colId, shouldBeVisible);
            if (!shouldBeVisible) {
                // If any "hidden" column - display toggle column
                displayToggleColumn = true;
            }
        });
        this.gridColumnApi?.setColumnVisible(
            this.detailsToggleColDef.colId,
            displayToggleColumn
        );
        setTimeout(() => {
            // Resizing the window with a detail view expanded won't force agInit or refresh unless we force redraw of rows.
            this.gridApi?.redrawRows();
            this.initColumnSizing();
        }, 200);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        // Todo - if this happens on logout - the user name is not available and will be stored as n/a
        this.saveTableState();
    }

    private setData(responseData) {
        // Parse data in frontend that is not possible to do in backend.
        // This is an ugly solution but a must for not changing the main
        // architecture of the backend application.
        if (responseData) {
            let knownGroups = {};

            for (let row of responseData) {
                // If we have a parent account id, apply name as well to the
                // account object.
                if (row.account?.parentAccountId) {
                    const acct = this.acctsQuery.getEntity(row.account.parentAccountId);
                    row.account.parentAccountName = acct?.accountClientAlias;
                }

                if (this.tableIsAmendable) {
                    // We know if a transaction group is amendable already from the first check, so no need to check ALL rows if group is already checked
                    if (row.transactionGroupId in knownGroups) {
                        row.isAmendable = knownGroups[row.transactionGroupId];
                    } else {
                        const transactionGroup = responseData.filter(
                            (rows) => rows.transactionGroupId === row.transactionGroupId
                        );
                        const groupIsAmendable =
                            this._amendService.verifyGroupIsAmendable(transactionGroup);
                        row.isAmendable = groupIsAmendable;
                        knownGroups[row.transactionGroupId] = groupIsAmendable;
                    }
                }
            }
        }

        if (this.paginated && responseData.content) {
            this.rowData = responseData.content;
        } else {
            this.rowData = responseData;
        }

        this.eventBus.emit(
            {
                payload: { rowDataLength: this.rowData ? this.rowData.length : 0 },
                source: this.context.widgetId,
                topic: SbEventTopic.GridDataSet
            },
            true
        );
    }

    setAutoGroupColumnDef() {
        this.autoGroupColumnDef = {
            cellRendererParams: {
                footerValueGetter: (params) => {
                    const isRootLevel = params.node.level === -1;
                    if (!isRootLevel && params?.value) {
                        return `Total ${this.translateService.instant(params.value)}`;
                    }
                    return 'Total';
                }
            }
        };
    }

    onModelUpdated() {
        if (!this.initialDataLoaded && this.gridApi) {
            this.initColumnSizing();
            // Todo - use if condition whether or not to use this - calling restoreTableState will always happen after column resizing
            // this.restoreTableState(); // Todo - fix loading of table states
            this.initialDataLoaded = true;
        }
    }

    initColumnSizing() {
        if (this.context.sizeColumnsToFit) {
            this.gridApi.sizeColumnsToFit();
        } else {
            this.gridColumnApi.autoSizeAllColumns();
        }
    }

    registerEventListeners(): any {
        const sub = this.eventBus
            .getObservable(SbEventTopic.TabPanelTabChange)
            .subscribe((event) => {
                setTimeout(() => {
                    if (this.gridApi) {
                        this.gridApi.sizeColumnsToFit();
                    }
                });
            });
        this.subscriptions.push(sub);
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridApi.hideOverlay();
        this.gridColumnApi = params.columnApi;
        if (this.sideBar) {
            this.gridApi.closeToolPanel();
        }
        if (this.context?.responsiveColumns) {
            const sub = this.ui.viewportSize$.subscribe((s) => {
                this.toggleResponsiveColumns(s);
            });
            this.subscriptions.push(sub);
        }
        if (this.context.sizeColumnsToFit) {
            window.addEventListener('resize', function () {
                setTimeout(function () {
                    if (params && params.api) {
                        params.api.sizeColumnsToFit();
                    }
                });
            });
        }
        this.registerPrintListener();
        // Forcing the aggregation functions to trigger again after grid ready since we need the gridColumnApi for calculating aggregates.
        this.gridApi.refreshClientSideRowModel('aggregate');
        this.initColumnSizing();
        // this.restoreTableState();
    }

    onViewGridReady(params) {
        this.viewGridApi = params.api;
        this.viewColumnApi = params.columnApi;
    }

    registerPrintListener() {
        const sub = this.eventBus.getObservable(SbEventTopic.Print).subscribe(
            (event) => {
                if (event) {
                    if (event.payload === 'Printing') {
                        this.setPrinterFriendly();
                    } else if (event.payload === 'notPrint') {
                        // Condition to set ag-grid outside print preview component
                        this.resetLayoutAfterPrint();
                    } else {
                        this.initColumnSizing();
                        this.toggleCompactMode(true);
                    }
                }
            },
            (error) => console.error(error)
        );
        this.subscriptions.push(sub);
    }
    onAutoHeight() {
        // Toggle domLayout (we do not need to consider print here since it's just applied when printing)
        this.domLayout = this.domLayout === 'autoHeight' ? 'normal' : 'autoHeight';
        this.autoHeightToolTip =
            this.domLayout === 'autoHeight'
                ? 'Fixed Height (Scroll)'
                : 'Auto Adjust Height';
        this.autoHeightIcon =
            this.domLayout === 'autoHeight'
                ? 'fa ui-icon-crop-7-5'
                : 'fa ui-icon-import-export';
        this.gridApi.setDomLayout(this.domLayout);
    }
    onShrinkColumnsToFit() {
        this.gridApi.sizeColumnsToFit();
    }
    onAutoSizeAll() {
        this.gridColumnApi.autoSizeAllColumns();
    }
    onResetLayout() {
        this.gridColumnApi.resetColumnState();
        this.gridColumnApi.resetColumnGroupState();
        const originalDomLayout = this.context.gridOptions
            ? this.context.gridOptions.domLayout
            : undefined;
        this.gridApi.setDomLayout(originalDomLayout);
        this.domLayout = originalDomLayout;
        // Todo DRY
        this.autoHeightToolTip =
            this.domLayout === 'autoHeight'
                ? 'Fixed Height (Scroll)'
                : 'Auto Adjust Height';
        this.autoHeightIcon =
            this.domLayout === 'autoHeight'
                ? 'fa ui-icon-crop-7-5'
                : 'fa ui-icon-import-export';
        this.toggleCompactMode(this.context.compactMode);
        this.initColumnSizing();
    }
    onCondensed() {
        this.toggleCompactMode(!this.isCondensed);
    }

    toggleCompactMode(compact: boolean) {
        if (compact) {
            this.isCondensed = true;
            this.compactIcon = 'fa ui-icon-unfold-more';
            this.compactTooltip = 'Normal View';
            this.setRowHeights(20, 34);
        } else {
            this.isCondensed = false;
            this.compactIcon = 'fa ui-icon-unfold-less';
            this.compactTooltip = 'Compact View';
            this.setRowHeights(32, 28);
        }
    }

    setPrinterFriendly() {
        this.isCondensed = true;
        this.setRowHeights(20, 34);
        this.gridApi.setDomLayout('print');
    }

    resetLayoutAfterPrint() {
        this.isCondensed = false;
        this.gridApi.setDomLayout(this.domLayout);
        this.setRowHeights(32, 28);
    }

    setRowHeights(rowHeight: number, headerHeight: number) {
        this.rowHeight = rowHeight;
        this.gridApi.setHeaderHeight(headerHeight);
        this.gridApi.resetRowHeights();
        this.gridApi.refreshGroupRows();
    }

    exportExcel() {
        this.gridApi.exportDataAsExcel(/* reverted this change since '< 0.0001' is not a valid number in csv and users won't be able to use it in calculations.
            processCellCallback: (params) => {
                if (typeof params.value === 'number' && Math.abs(params.value) < 0.0001) {
                    return '< 0.0001';
                } else {
                    return params.value;
                }
            }
        }*/);
    }

    exportCsv() {
        this.gridApi
            .exportDataAsCsv
            /* reverted this change since '< 0.0001' is not a valid number in csv and users won't be able to use it in calculations.
            processCellCallback: (params) => {
                if (typeof params.value === 'number' && Math.abs(params.value) < 0.0001) {
                    return '< 0.0001';
                } else {
                    return params.value;
                }
            }
        }*/
            ();
    }

    getMainMenuItems() {
        // params.defaultItems.push('rowGroup');
        // params.defaultItems.push('rowUnGroup');
        return [
            'pinSubMenu',
            'autoSizeThis',
            'autoSizeAll',
            'valueAggSubMenu',
            'rowGroup',
            'rowUnGroup',
            'resetColumns',
            'expandAll',
            'contractAll'
        ];
    }

    saveTableState() {
        if (this.gridColumnApi && this.gridApi) {
            this.storageService.localSet(
                this.context.widgetId,
                'colState',
                this.gridColumnApi.getColumnState()
            );
            this.storageService.localSet(
                this.context.widgetId,
                'sortState',
                this.gridApi.getSortModel()
            );
            this.storageService.localSet(
                this.context.widgetId,
                'filterState',
                this.gridApi.getFilterModel()
            );
        }
    }

    isSaved(): boolean {
        return this.storageService.localGet(this.context.widgetId, 'colState')
            ? true
            : false;
    }

    onKeyDown(event) {
        const keyboardEvent = event.event as KeyboardEvent;
        if (keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete') {
            event.newValue = undefined;
            this.onCellEditingChanged(event);
            this.gridApi.stopEditing(true);
            return true;
        }
    }

    restoreTableState() {
        const columnState = this.storageService.localGet(
            this.context.widgetId,
            'colState'
        );
        if (columnState) {
            this.gridColumnApi.setColumnState(columnState);
        }
        const sortState = this.storageService.localGet(
            this.context.widgetId,
            'sortState'
        );
        if (sortState) {
            this.gridApi.setSortModel(sortState);
        }
        const filterState = this.storageService.localGet(
            this.context.widgetId,
            'filterState'
        );
        if (filterState) {
            this.gridApi.setFilterModel(filterState);
        }
    }

    resetTableState() {
        this.gridColumnApi.resetColumnState();
        this.gridApi.setFilterModel(null);
        this.gridApi.setSortModel(null);
        this.storageService.localRemove(this.context.widgetId, 'colState');
        this.storageService.localRemove(this.context.widgetId, 'sortState');
        this.storageService.localRemove(this.context.widgetId, 'filterState');
    }

    onRowClicked() {}

    displayDropDownButton() {
        return this.showAdvancedToolbar || !this.context.suppressExcelExport;
    }

    /**
     * Trigger an event that makes it possible to listen to row selects in tables.
     * Will only work if we have "rowSelection" set to "single" (and probably "multiple but it might not make sense to use it there")
     * in gridOptions.
     * @param event event from ag grid containing rowData as .data property (as received from server side model).
     */
    onRowSelected(event) {
        /*
         * onRowSelected is fired twice in ag-grid - first for the row selected and then for the row deselected.
         * Only publish first row until we have a need for a "TableRowDeselected" event.
         * Annoyingly there is no flag telling which one is which --> check event.node.selected for the one currently selected.
         */
        if (!event.node.selected) {
            return;
        }
        const payload: SbEvent = {
            source: this.context.widgetId,
            topic: SbEventTopic.TableRowSelected,
            payload: event.data
        };
        this.eventBus.emit(payload);
    }

    onRowDoubleClicked(event) {
        const routingConfig = this.context.doubleClick;
        if (!routingConfig?.targetUrl) {
            return;
        }

        let expressionGuard = true;
        if (routingConfig.guard) {
            const f = new Function('data', routingConfig.guard);
            expressionGuard = f(event.data);
            if (!expressionGuard) {
                return;
            }
        }

        if (routingConfig.queryParameters) {
            const params = {};
            routingConfig.queryParameters.forEach((qp) => {
                params[qp.queryParamName] = event.data[qp.sourcePath] || qp.defaultValue;
            });
            this.router.navigate([routingConfig.targetUrl], { queryParams: params });
        } else {
            const targetUrl = '/' + routingConfig.targetUrl;
            const id = routingConfig.idField ? event.data[routingConfig.idField] : null;
            this.router.navigate([targetUrl, id]);
        }
    }

    buttonClicked(targetURL) {
        this.router.navigate([targetURL]);
    }

    getMappedValues(api: GridApi, rowNode: RowNode, fieldMappings: FieldMapping[]) {
        const temporaryObject = {};
        fieldMappings.forEach((fm) => {
            temporaryObject[fm.source] = api.getValue(fm.source, rowNode);
        });
        return temporaryObject;
    }

    getContextMenuItems(params) {
        // Righ click behavior should be decided by template component.
        if (params.node.detail) return [];
        const rowData = params.node.data;
        const componentParent = params.context.componentParent;
        // union mellan default och de satta i context.
        const menuItems = componentParent.context.contextMenuItems;
        if (!menuItems) {
            // Unless configured we don't want any right click menu
            return [];
        }

        const sessionQuery = <SessionQuery>componentParent.sessionQuery;
        const filteredItems = menuItems.filter((menuItem) => {
            let expressionGuard = true;
            if (menuItem.guard) {
                const f = new Function('data', menuItem.guard);
                expressionGuard = f(rowData);
            }
            return menuItem.accessRight
                ? sessionQuery.hasScopeAccess(menuItem.accessRight) && expressionGuard
                : expressionGuard;
        });

        return [
            ...filteredItems.map((menuItem) => ({
                name: menuItem.name,
                guard: menuItem.guard,
                params: params,
                parent: componentParent,
                actionPath: menuItem.action,
                action: function () {
                    this.params.context.componentParent.menuSelected(this);
                },
                accessRight: menuItem.accessRight
            }))
        ];
    }

    editable(params) {
        if (params.colDef.hasOwnProperty('editable.expression.path')) {
            const path = params.colDef['editable.expression.path'];
            return get(params.data, path, false);
        } else {
            return false;
        }
    }

    cellStyle(params) {
        if (
            !this.editable(params) &&
            params.colDef.hasOwnProperty('editable.expression.path')
        ) {
            return { backgroundColor: 'lightgray' };
        } else {
            return null;
        }
    }

    menuSelected({
        actionPath: { path = {}, requestMapping = [] } = {},
        params: {
            api,
            node: { data },
            value
        }
    }) {
        const gridApi = <GridApi>api;
        // Post to end-point defined in path
        const requestParams = transformModel(data, false, requestMapping);
        const method = (<SbPath>path).httpMethod || 'POST';
        if (method === 'AMEND') {
            // Which form to redirect to depends on table row data
            // Passing row data means we will insert the table data into the transactions store to be reusable
            this._amendService.redirectToForm(data, this.rowData);
            return;
        }
        const url = this.dataService.getResourceUrl(<SbPath>path);
        this.confirmDialogService
            .confirmDialog({
                title: 'Confirmation',
                message: `Please confirm your action?`,
                cancelText: `No`,
                confirmText: `Yes`
            })
            .subscribe((res) => {
                if (res) {
                    this.http.request(method, url, { params: requestParams }).subscribe(
                        (response) => {
                            (<any[]>response).forEach((rowData) => {
                                const rowId = this.getRowNodeId(rowData);
                                const rowNode = gridApi.getRowNode(rowId);
                                if (method === 'DELETE') {
                                    gridApi.updateRowData({ remove: [rowData] });
                                } else if (rowNode) {
                                    rowNode.setData(rowData);
                                    gridApi.flashCells({
                                        rowNodes: [rowNode]
                                    });
                                }
                            });
                            this.toastService.show({
                                intent: 'success',
                                message: 'Your action completed successfully.',
                                title: 'Action Successful'
                            });
                        },
                        () => {
                            this.toastService.show({
                                intent: 'critical',
                                message:
                                    'Your action was not successful. Please try again or investigate inconsistencies.',
                                title: 'Action Failed'
                            });
                        }
                    );
                }
            });
    }

    onCellEditingChanged(params: ValueSetterParams): boolean {
        if (this.context.cellEditorConfig && this.context.cellEditorConfig.default) {
            const path = this.context.cellEditorConfig.default.path;
            const method = path.httpMethod || 'POST';
            const temporaryObject = this.getMappedValues(
                params.api,
                params.node,
                this.context.fieldMapping
            );
            Object.assign(temporaryObject, params.data);
            temporaryObject[params.colDef.field] = params.newValue;
            temporaryObject['newValue'] = params.newValue;
            temporaryObject['sourceField'] = params.colDef.field;
            const url = this.dataService.getResourceUrl(path, SbHost.GatewayBaseUrl);
            const body = transformModel(
                temporaryObject,
                false,
                this.context.fieldMapping
            );
            this.http
                .request(method, url, {
                    body
                })
                .subscribe(
                    (response) => {
                        params.node.setData(response);
                        params.api.flashCells({
                            rowNodes: [params.node],
                            columns: [params.colDef.field]
                        });
                        console.info('Successfully saved cell value: ' + params.newValue);
                    },
                    (err) => {
                        console.error('Failed to save cell value: ' + params.newValue);
                        // alert('Failed to save cell value.');
                        params.data[params.colDef.field] = params.oldValue;
                        this.snackBar.openFromComponent(SbSnackbarComponent, {
                            duration: 5000,
                            horizontalPosition: 'center',
                            verticalPosition: 'top',
                            data: {
                                severity: 'error',
                                summary: 'Failed to update row',
                                detail: err.error.error
                            }
                        });
                    }
                );
        } else {
            console.warn('No cell editor configuration found in widget configuration.');
        }
        return true;
    }

    private isExcludedFromBeingHidden(eventSource: string) {
        return [
            'list-limits',
            'list-transactions',
            'list-positions',
            'view-positions',
            'list-issuers',
            'list-issuer-contact-persons',
            'list-organisations',
            'list-persons',
            'list-accounts'
        ].includes(eventSource);
    }
}
